import { BodyText } from "@/components/ui";

export const ClosedForInactivityMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        Marked encounter as incomplete due to patient inactivity.
      </BodyText>
    </div>
  );
};
